import { useEffect, useState } from "react"

const resizeObserver = new ResizeObserver(entries => {
  entries.forEach(entry => {
    const match = subscribers.find(subscriber => subscriber.target === entry.target)

    if (match) {
      match.listener(entry)
    }
  })
})

let subscribers = []

function attach(target, listener) {
  if (!target) {
    return
  }
  const match = subscribers.find(subscriber => subscriber.target === target)
  if (match) {
    match.listener = listener
  } else {
    subscribers.push({ target, listener })
  }
}

function detach(target) {
  subscribers = subscribers.filter(subscriber => subscriber.target !== target)
}

export default function useResizeObserver(listener) {
  const [ref, setRef] = useState()

  useEffect(() => {
    attach(ref, listener)
  }, [ref, listener])

  useEffect(() => {
    if (ref) {
      resizeObserver.observe(ref)

      return () => {
        resizeObserver.unobserve(ref)
        detach(ref)
      }
    }
  }, [ref])

  return { ref, setRef }
}
